import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import Utils from "../../../../../utils/Utils";
import Button from "../../../../../components/button/Button"
import OggettiUtili from "../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente"
import Ruoli from "../../../../../utils/Ruoli"
import SegnalazioniService from '../../../../../services/SegnalazioniServices';
import ToasterSingleton from "../../../../../singleton/ToasterSingleton";
import Modale from "../../../../../components/modale/Modale";
import $ from "jquery";
import Icon from "../../../../../components/icon/Icon";
import toasterConfig from "../../../../../config/toasterConfig";
import globals from "../../../../../config/appconfig";


class SchedaSpecialeGenerica extends Component {

    state = {
        malattiePerCodice: JSON.parse(sessionStorage.getItem("malattiePerCodice")),
        corretto: false,
        pdfAssociato: false,
        pdfInviato: false,
        file: null,
        mailInviataCorrettamente: false,
        disabled: false
    }

    constructor(props) {
        super(props)
        this.uploadFile = this.uploadFile.bind(this)
        this.gestioneMessageEmail = this.gestioneMessageEmail.bind(this)
    }



    componentDidMount() {

        if (this.props.segnalazioneCopia) {
            this.setState({
                disabled: (this.props.segnalazione && this.props.segnalazione.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice),
                pdfAssociato: this.props.segnalazioneCopia.pdfAssociato,
                pdfInviato: this.props.segnalazioneCopia.pdfInviato
            })
        }
        this.props.setSchedaSpecialeECorretto({}, null, this.props.segnalazioneCopia.pdfAssociato)  //non passo validate e corretto, non ci sono controlli di validità
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!Utils.areObjectsEquivalent(prevProps.segnalazioneCopia, this.props.segnalazioneCopia)) {
            this.setState({
                disabled: (this.props.segnalazione && this.props.segnalazione.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice),
                pdfAssociato: this.props.segnalazioneCopia.pdfAssociato,
                pdfInviato: this.props.segnalazioneCopia.pdfInviato
            })
        }
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
        ToasterSingleton.instance().pulisci()
    }

    invioScheda() {
        this.props.showSpinner(true);
        if (SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione) {
            SegnalazioniService.postInviaPdf(this.props.segnalazioneCopia.idSegnalazione)
                .then((data) => {
                    this.props.showSpinner(false);
                    if (data && data.status === 200) {
                        let segnalazioneSalvata = this.props.segnalazioneCopia;
                        segnalazioneSalvata["pdfInviato"] = data.data.pdfInviato
                        // this.props.segnalazioneCopia = segnalazioneSalvata
                        let state = this.state
                        state.pdfInviato = data.data.pdfInviato
                        $('#modalButton_confermaInvioScheda').trigger('click');
                        this.setState({state: state})
                    }
                });
        }

    }

    async uploadFile(event) {
        this.props.showSpinner(true);
        let dimensioneMassimaFile = parseInt(globals["dimesione-massima-file"])
        let file = event.target.files[0]
        if (file !== undefined && file.type !== undefined) {
            if (file.type !== "application/pdf") {
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_CARICAMENTOFILE"]);
            } else if(file.size > dimensioneMassimaFile){
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_LIMIT_DIMENSIONEFILE"]);
            }else {
                let base64 = await Utils.toBase64(file);
                SegnalazioniService.postCaricaPdf(this.props.segnalazioneCopia.idSegnalazione, base64).then((data) => {
                    this.props.caricaPdf(data)
                    this.setState({pdfAssociato: true, mailInviataCorrettamente: data.data.mailInviataCorrettamente})
                    this.props.setSchedaSpecialeECorretto({}, null, true, null, null, true)
                    this.props.showSpinner(false);
                    this.aggiungiToaster(toasterConfig.types.successo, ["Messages.MSG_200_CARICAMENTOFILE"]);
                    if (this.props.segnalazioneCopia.malattia !== "0578" && this.props.segnalazioneCopia.malattia !== "0669") {
                        $('#modalButton_confermaInvioPdf').trigger('click')
                    }


                }).catch((err) => {
                    console.log(err)
                    this.props.showSpinner(false);
                })
            }
        } else {
            this.props.showSpinner(false);
        }
    }


    aggiungiToaster(type, text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: type,
            text: text,
            timestamp: Date.now()
        })
    }

    gestioneMessageEmail(){
        if(this.props.segnalazioneCopia && this.props.segnalazioneCopia.malattia && this.props.segnalazioneCopia.malattia === "0664"){
            return "L’invio della scheda alla Regione è avvenuto correttamente"
        }
        else{
            return "L’invio della scheda all'Istituto Superiore di Sanità è avvenuto correttamente"
        }
    }

    render() {

        const {t} = this.props;


        const sezione2 = (
            <div className="row">
                <div className={"col-lg-12"} style={{marginTop: "1rem"}}>
                    <table className="table table-bordered">
                        <thead>
                        <tr className="table-info">
                            <td scope="col">{t("Tables.Home.malattia")}</td>
                            <td scope="col">{t("GestioneSegnalazioni.ricerca.id_segnalazione")}</td>
                            <td scope="col">{t("Tables.Home.data")}</td>
                            <td scope="col">{t("SchedaInfluenzaGrave.ulss")}</td>
                            <td scope="col"/>
                            {this.state.pdfAssociato ? <td scope="col"/> : null}
                            {SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione && this.props.segnalazioneCopia.malattia !== "0578"?
                                <td scope="col"/> : null}
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                {this.props.segnalazioneCopia.malattia ? this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].descrizione : ""}

                            </td>
                            <td>
                                {this.props.segnalazioneCopia.ulssSegnalazione + ("" + this.props.segnalazioneCopia.idSegnalazione).padStart(9, "0")}


                            </td>

                            <td>  {Utils.transformDateForFrontend(this.props.segnalazioneCopia.dataSegnalazione)}</td>

                            <td>
                                {this.props.segnalazioneCopia.ulssSegnalazione && OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione] ? OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione].descrizione : ""}
                            </td>

                            {SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione ?
                                <td>
                                    <div className="row justify-content-center">
                                        {
                                            !this.state.pdfAssociato ?
                                                <label className="btnBlu" style={{
                                                    width: "150px",
                                                    height: "40px",
                                                    opacity: this.props.segnalazioneCopia && this.props.segnalazioneCopia.statoValidazione === "01" ? "0.6" : "1"
                                                }}>
                                                    <input type="file"
                                                           onChange={this.uploadFile}
                                                           style={{display: "none"}}
                                                           accept="application/pdf"
                                                           disabled={this.state.disabled}
                                                    />
                                                    <p style={{marginTop: "7%", marginLeft: "5%", marginRight: "5%"}}>
                                                        {t("SchedaFlussoSpeciale.Button.carica")}</p>
                                                </label> :

                                                <Button style={{width: "150px", height: "40px"}}
                                                        text={t("SchedaFlussoSpeciale.Button.visualizza_pdf")}
                                                        onClick={(e) => {Utils.visualizzaPdf(e,null,this.props.segnalazioneCopia,this.props.showSpinner)}}
                                                        className="btnBlu "/>

                                        }

                                    </div>
                                </td>
                                :
                                null
                            }

                            {
                                this.state.pdfAssociato ?


                                    <td>


                                        <div className="row justify-content-center">

                                            <label className="btnBlu" style={{width: "150px", height: "40px", opacity: this.props.segnalazioneCopia && this.props.segnalazioneCopia.statoValidazione === "01" ? "0.6" : "1"}}>
                                                <input type="file"
                                                       onChange={this.uploadFile}
                                                       style={{display: "none"}}
                                                       accept="application/pdf"
                                                       placeholder={t("SchedaFlussoSpeciale.Button.carica_nuovo_pdf")}
                                                       disabled={this.state.disabled}
                                                />
                                                <p style={{marginTop: "2%", marginLeft: "5%", marginRight: "5%"}}>
                                                    {t("SchedaFlussoSpeciale.Button.carica_nuovo_pdf")}</p>
                                            </label>
                                        </div>

                                    </td>
                                    :
                                    null


                            }
                            {
                                SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione && this.props.segnalazioneCopia.malattia !== "0578"?
                                    <td>

                                        <div className="row justify-content-center">
                                            <Button style={{width: "150px", height: "40px"}}
                                                    disabled={this.state.disabled || (((!this.state.pdfAssociato || !this.props.segnalazioneCopia.stepConfermati.schedaSpecialeConfermata)
                                                            || this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].codice === "0413" || this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].codice === "0669")
                                                        || this.props.segnalazioneCopia.pdfInviato === true)}
                                                    text={t("SchedaFlussoSpeciale.Button.invia_pdf")}
                                                    className="btnBlu "
                                                    onClick={() => {
                                                        this.invioScheda()
                                                    }}
                                            />
                                            {
                                                this.props.segnalazioneCopia.pdfInviato ?
                                                    <Icon id="it-check-circle" classes={"icon-sm ml-1 mt-2"}
                                                          style={{fill: "#008000"}}/>
                                                    :
                                                    null
                                            }
                                        </div>

                                    </td>
                                    :
                                    null
                            }

                        </tr>

                        </tbody>


                    </table>
                </div>
            </div>
        );

        const modaleConfermaInvioScheda = (
            <div>
                <Modale classes="btnWhite"
                        soloModale={true}
                        buttonMail={true}
                        id={"confermaInvioScheda"}
                        name={"Conferma Invio Scheda"}
                        typeModal="modalConsenso"
                        modalText={this.state.pdfInviato ? this.gestioneMessageEmail() :
                            "Invio e-mail non riuscito. Non è stato possibile inviare la scheda"}
                        text={t("Buttons.conferma")}
                        title={t("Buttons.notificaMail")}
                        textButtonOk={"OK"}
                        style={{height: "3rem", marginTop: "1rem"}}
                />
            </div>
        )

        const modaleConfermaInvioPdf = (
            <div>
                <Modale classes="btnWhite"
                        soloModale={true}
                        buttonMail={true}
                        id={"confermaInvioPdf"}
                        name={"Conferma Invio Pdf"}
                        typeModal="modalConsenso"
                        modalText={this.state.mailInviataCorrettamente ? "Il caricamento è stato correttamente notificato via e-mail alla Regione" :
                            "Invio e-mail non riuscito. Non è stato possibile inviare la scheda"}
                        text={t("Buttons.conferma")}
                        title={t("Buttons.notificaMail")}
                        textButtonOk={"OK"}
                        style={{height: "3rem", marginTop: "1rem"}}
                />
            </div>
        )


        return <div>{sezione2} {modaleConfermaInvioScheda} {modaleConfermaInvioPdf}</div>
    }


}

export default withTranslation('common')(SchedaSpecialeGenerica)
